<i18n>
{
    "uk": {
        "tags": {
            "format": {
                "record" : "Онлайн-курс в записі",
                "live" : "Онлайн-курс наживо",
                "intensive" : "Інтенсив",
                "webinar": "Вебінар",
                "workshop": "Онлайн-воркшоп"
            },

            "premiere": "Прем’єра",
            "start": "Початок: {date}",

            "soon": "незабаром"
        },

        "stats": {
            "students": "немає студентів | студент | студента | студентів"
        },

        "features": {
            "modules" : "немає модулів | {n} модуль | {n} модулі | {n} модулів",
            "lessons" : "немає занять | {n} заняття | {n} заняття | {n} занять",

            "types": {
                "theoryPractice": "Теорія та практика",
                "theory": "Теорія",
                "practice": "Практика"
            }
        },

        "partners": {
            "caption": "Партнер курсу | Партнер курсу | Партнери курсу | Партнери курсу",
            "and": "та"
        },

        "pricing": {
            "free": "Подія безплатна",
            "subbed": "Подія входить у&nbsp;вашу передплату",
            "bought": "Ви придбали цю подію",

            "canSub": "Ви&nbsp;можете зареєструватись за&nbsp;передплатою",

            "canSubShort": "Зареєструватись за&nbsp;передплатою",
            "canBuyShort": "ви&nbsp;можете придбати&nbsp;її",
            "canBuyForever": "Купити цю&nbsp;подію",

            "fromPrice": "від&nbsp;{price}",
            "fullPrice": "Повна ціна події",
            "customPrice": "Доступ до&nbsp;благодійної події за&nbsp;донат",

            "subscribe": "оформити",
            "choosePlan": "підібрати тариф",
            "buyForever": "купити назавжди",

            "uahMon": "₴/міс.",
            "uah": "₴",

            "or": "або",
            "but": "але"
        },

        "actions": {
            "program": "Програма події",
            "preregister": "Хочу піти",
            "trial": "Спробувати 7 днів безплатно",
            "buy": "Зареєструватись",
            "subscribe": "Оформити передплату",
            "join": "Зареєструватись",
            "register": "Зареєструватись",
            "toCourse": "До події"
        },

        "scroll-hint": "гортайте, щоб дізнатись більше"
    },
    "en": {
        "tags": {
            "format": {
                "record" : "Recorded online course",
                "live" : "Live online course",
                "intensive" : "Intensive",
                "webinar": "Webinar",
                "workshop": "Online Workshop"
            },

            "premiere": "Premiere",
            "start": "Starts on: {date}",

            "soon": "soon"
        },

        "stats": {
            "students": "no students | student | students"
        },

        "features": {
            "modules" : "no modules | {n} module | {n} modules",
            "lessons" : "no lessons | {n} lesson | {n} lessons",

            "types": {
                "theoryPractice": "Theory and practice",
                "theory": "Theory",
                "practice": "Practice"
            }
        },

        "partners": {
            "caption": "Course partner | Course partner | Course partners",
            "and": "and"
        },

        "pricing": {
            "free": "Free event",
            "subbed": "Event is&nbsp;included in&nbsp;your subscription",
            "bought": "You have bought this event",

            "canSub": "You&nbsp;can join this&nbsp;event by&nbsp;subscription",

            "canSubShort": "Join by&nbsp;subscription",
            "canBuyShort": "you&nbsp;can buy&nbsp;it",
            "canBuyForever": "Buy this&nbsp;event forever",

            "fromPrice": "from&nbsp;{price}",
            "fullPrice": "Full event price",
            "customPrice": "Access to&nbsp;the&nbsp;charity event for&nbsp;a&nbsp;donation",

            "subscribe": "subscribe",
            "choosePlan": "choose plan",
            "buyForever": "buy forever",

            "uahMon": "UAH/mon",
            "uah": "UAH",

            "or": "or",
            "but": "but"
        },

        "actions": {
            "program": "Event program",
            "preregister": "Register for the event",
            "trial": "Try 7 days free",
            "buy": "Buy event",
            "subscribe": "Subscribe",
            "join": "Join event",
            "register": "Register for the event",
            "toCourse": "To event"
        },

        "scroll-hint": "Scroll to learn more"
    }
}
</i18n>


<template>
    <div
        :id="block.id || `${block.type}-${uid}`"
        class="hero-block mt-sm-3 mt-lg-0"
        :class="`${heroVisual.dark && 'dark' || ''} ${heroVisual.btnLight ? 'hero-btn-light' : ''} ${block.class || ''}`"
        ref="hero"
        :style="{
            'min-height':       `${contentHeight}px`,
            '--hero-btn-hue':   heroVisual.btnHue,
            '--hero-btn-sat':   `${heroVisual.btnSaturation}%`,
            '--hero-btn-light': `${heroVisual.btnLightness}%`,
        }"
    >

        <!-- Edit button -->
        <div
            v-if="edit"
            class="edit"
        >
            <button
                class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                @click="$emit('openHeroEditor')"
            />
        </div>


        <!-- Background visual -->
        <div
            class="hero-visual"
            :style="{
                'background-color': heroVisual.color
            }"
        >
            <!-- Image -->
            <div class="page-container">
                <div
                    class="visual mt-sm-2 mt-md-3 mt-lg-0"
                    :class="{
                        'mask': heroVisual.mask || !heroVisual.image,
                        'fallback': !heroVisual.mobile,
                        'lg-fallback': !heroVisual.image,
                    }"
                />
            </div>
        </div>

        <!-- Content -->
        <div
            ref="content"
            class="hero-content"
        >
            <div class="page-container">

                <div class="row mb-lg-6">
                    <div class="col-12 col-lg-6">

                        <!-- Features -->
                        <div
                            class="transition-up-2 d-flex align-items-center f-semismall fw-700 mt-1h mt-md-2 mt-lg-0 justify-content-center justify-content-lg-start"
                            :class="heroFeatures.class"
                        >

                            <div class="feature tt-upper">
                                <WebpPicture
                                    imgClass="block-image mr-1"
                                    src="https://cdn.cases.media/image/original/calendar-icon.png"
                                    alt="calendar"
                                    width="20"
                                    height="20"
                                />
                                {{ dates }}
                            </div>

                            <!-- Module types -->
                            <div
                                class="feature type tt-upper"
                            >
                                {{ type}}
                            </div>

                            <!-- Custom -->
                            <div
                                v-for="(feature, i) in heroFeatures.items"
                                :key="`feature-custom-${i}`"
                                class="feature custom"
                            >
                                {{ feature }}
                            </div>

                            <div class="feature d-none d-sm-inline-flex d-lg-none" v-if="heroPricing.price">
                                <strike v-if="heroPricing.discount" class="color-gray-3 mr-h">{{ heroPricing.price }}</strike>

                                {{ heroPricing.discount || heroPricing.price }} {{ heroPricing.suffix || $t('pricing.uah', locale) }}

                                <span v-if="heroPricing.discountBadge" class="pricing-discount" v-html="heroPricing.discountBadge" />
                            </div>
                        </div>

                        <!-- Title -->
                        <h1
                            class="hero-title fw-800 transition-up-1 my-1h my-md-2 ta-center ta-lg-left"
                            :class="heroTitle.class"
                            v-html="heroTitle.text"
                        />


                        <!-- About -->
                        <div
                            v-if="block.about"
                            class="hero-about transition-up-2 my-1h my-md-2 ta-center ta-lg-left"
                            :class="heroAbout.class"
                            v-html="heroAbout.text"
                        />



                        <!-- Pricing -->
                        <div
                            v-if="!isEnrollClosed && (hasAccess || ((canBuyAccess && course.buyAccess) || canSubAccess))"
                            class="hero-pricing transition-up-3"
                        >
                            <div class="pricing-backdrop">

                                <!-- Badge: free -->
                                <div v-if="isFree" class="pricing-access" v-html="heroPricing?.label?.free || $t('pricing.free', locale)" />

                                <template v-else-if="canBuyAccess && canSubAccess">
                                    <!-- State: both buy and sub accesses possible -->

                                    <!-- Badge: bought -->
                                    <div v-if="isBought" class="pricing-access" v-html="heroPricing?.label?.bought || $t('pricing.bought', locale)" />

                                    <div v-else class="pricing-group">

                                        <!-- Badge: included in subscription -->
                                        <div v-if="hasAccess" class="pricing-access groupped" v-html="heroPricing?.label?.subbed || $t('pricing.subbed')" />

                                        <!-- Price: subscription -->
                                        <template v-else>
                                            <Component
                                                :is="hasSubscribePricingLink ? 'nuxt-link' : 'div'"
                                                :tag="hasSubscribePricingLink ? 'a' : 'div'"
                                                :to="hasSubscribePricingLink && localePath('/learning/subscription#plans')"
                                                :href="hasSubscribePricingLink && localePath('/learning/subscription#plans')"
                                                class="groupped"
                                                :class="{
                                                    'groupped-link': hasSubscribePricingLink
                                                }"
                                            >
                                                <div class="f-small mb-h mb-sm-0" v-html="$t('pricing.canSubShort', locale)" />

                                                <div class="pricing-price">
                                                    <span v-html="$t('pricing.fromPrice', {
                                                        price: subscriptionPrice,
                                                        locale
                                                    })" />

                                                    <sup>{{ $t('pricing.uahMon', locale) }}</sup>
                                                </div>

                                                <div v-if="hasSubscribePricingLink" class="pricing-link mt-h">
                                                    <!-- Link: select plan -->
                                                    <span
                                                        class="b-link"
                                                    >{{ $t('pricing.subscribe', locale) }}</span>
                                                </div>
                                            </Component>
                                        </template>

                                        <!-- or / but -->
                                        <div class="conj" v-html="$t(`pricing.${hasAccess ? 'but' : 'or'}`, locale)" />

                                        <!-- Price: buy -->
                                        <Component
                                            :is="hasBuyPricingLink ? (course.buyAccess ? 'AddToCart' : 'button') : 'div'"
                                            :tag="hasBuyPricingLink ? 'button' : 'div'"
                                            :modelName="hasBuyPricingLink && course.buyAccess ? 'access' : null"
                                            :modelId="hasBuyPricingLink && course.buyAccess ? course.buyAccess : null"
                                            v-scroll-to="hasBuyPricingLink && !course.buyAccess && buyBlockId ? {el: `#${buyBlockId}`, offset: linkOffset} : null"
                                            class="groupped"
                                            :class="{
                                                'groupped-link': hasBuyPricingLink
                                            }"
                                        >
                                            <div class="f-small mb-h mb-sm-0" v-html="$t(`pricing.${hasAccess ? 'canBuyShort' : 'canBuyForever'}`, locale)" />

                                            <div class="pricing-price">
                                                <strike v-if="heroPricing.discount" class="color-gray-3">{{ heroPricing.price }}</strike>

                                                {{ heroPricing.discount || heroPricing.price }}

                                                <sup>
                                                    {{ heroPricing.suffix || $t('pricing.uah', locale) }}

                                                    <span v-if="heroPricing.discountBadge" class="pricing-discount" v-html="heroPricing.discountBadge" />
                                                </sup>
                                            </div>

                                            <div v-if="hasSubscribePricingLink" class="pricing-link mt-h">
                                                <!-- Link: buy forever -->
                                                <span
                                                    class="b-link"
                                                >{{ $t('pricing.buyForever', locale) }}</span>
                                            </div>
                                        </Component>

                                    </div>

                                </template>

                                <!-- The second condition shows correct state when access bought even with legacy subOnly flag set -->
                                <template v-else-if="course.buyAccess || isBought">
                                    <!-- State: only buy access possible -->

                                    <!-- Badge: bought -->
                                    <div v-if="hasAccess" class="pricing-access" v-html="heroPricing?.label?.bought || $t('pricing.bought', locale)" />

                                    <!-- Price: custom price -->
                                    <div v-else-if="isCustomPrice" class="pricing-charity">
                                        <div>
                                            <div class="f-small" v-html="heroPricing?.label?.customPrice || $t('pricing.customPrice', locale)" />

                                            <div class="pricing-price">
                                                <span v-html="$t('pricing.fromPrice', {
                                                    price: heroPricing.minPrice,
                                                    locale
                                                })" />

                                                <sup v-html="heroPricing.suffix || $t('pricing.uah', locale)" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Price: buy -->
                                    <div v-else>
                                        <div class="pricing-price large">
                                            <strike v-if="heroPricing.discount" class="color-gray-3">{{ heroPricing.price }}</strike>

                                            {{ heroPricing.discount || heroPricing.price }}

                                            {{ heroPricing.suffix || $t(`pricing.${heroPricing.full ? 'uahMon' : 'uah'}`, locale) }}

                                            <sup>
                                                <span v-if="heroPricing.discountBadge" class="pricing-discount" v-html="heroPricing.discountBadge" />
                                            </sup>
                                        </div>
                                        <div v-if="heroPricing.full" class="f-small mt-h">
                                            <span class="color-gray-3" v-html="`${$t('pricing.fullPrice', locale)}:`" />

                                            <strike v-if="heroPricing.fullDiscount" class="color-gray-3">{{ heroPricing.full }}</strike>

                                            {{ heroPricing.fullDiscount || heroPricing.full }}
                                            {{ heroPricing.fullSuffix || $t('pricing.uah', locale) }}
                                        </div>
                                    </div>

                                </template>

                                <template v-else-if="canSubAccess">
                                    <!-- State: only sub access possible -->

                                    <!-- Badge: subscribed -->
                                    <div v-if="hasAccess" class="pricing-access" v-html="heroPricing?.label?.subbed || $t('pricing.subbed', locale)" />

                                    <!-- Price: subscription -->
                                    <Component
                                        v-else
                                        class="pricing-sub reset-btn"
                                        :is="hasSubscribePricingLink ? 'button' : 'div'"
                                        :tag="hasSubscribePricingLink ? 'button' : 'div'"
                                        v-scroll-to="hasSubscribePricingLink ? {el: `#${buyBlockId}`, offset: linkOffset} : null"
                                        :class="{
                                            'groupped-link': hasSubscribePricingLink
                                        }"
                                    >
                                        <div>
                                            <div class="f-small" v-html="$t('pricing.canSub', locale)" />

                                            <div class="pricing-price align-items-center">
                                                <span v-html="$t('pricing.fromPrice', {
                                                    price: subscriptionPrice,
                                                    locale
                                                })" />
                                                <span class="currency">{{ $t('pricing.uahMon', locale) }}</span>

                                                <!-- Link: select plan -->
                                                <span
                                                    v-if="hasSubscribePricingLink"
                                                    class="pricing-link b-link ml-h"
                                                    v-html="$t('pricing.choosePlan', locale)"
                                                />
                                            </div>
                                        </div>
                                    </Component>

                                </template>

                            </div>
                        </div>

                        <!-- Actions -->
                        <div class="hero-actions transition-up-3">
                            <div class="actions">

                                <!-- Link: program -->
                                <button
                                    v-if="programBlockId"
                                    v-scroll-to="{el: `#${programBlockId}`, offset: linkOffset}"
                                    class="action btn-primary"
                                >
                                    <span>{{ $t('actions.program', locale) }}</span>
                                </button>


                                <!-- Link: to course -->
                                <nuxt-link
                                    v-if="isJoined"
                                    :to="localePath(`/learning/course/${course.slug}`)"
                                    class="action btn-secondary btn-custom"
                                >
                                    <span>{{ $t('actions.toCourse', locale) }}</span>
                                </nuxt-link>


                                <!-- Can register (curated) -->
                                <button
                                    v-else-if="isCurated && (!hasAccess || isFree) && buyBlockId && !isEnrollClosed"
                                    v-scroll-to="{el: `#${buyBlockId}`, offset: linkOffset}"
                                    class="action btn-secondary btn-custom"
                                >{{ heroActions.button || $t('actions.register', locale) }}</button>


                                <!-- Link: buy -->
                                <template
                                    v-else-if="!hasAccess && !isJoined && !isEnrollClosed"
                                >
                                    <AddToCart
                                        v-if="canBuyAccess && course.buyAccess"
                                        modelName="access"
                                        :modelId="course.buyAccess"
                                        class="action btn-secondary btn-custom"
                                    >{{ heroActions.button || $t('actions.buy', locale) }}</AddToCart>

                                    <button
                                        v-else-if="buyBlockId"
                                        v-scroll-to="{el: `#${buyBlockId}`, offset: linkOffset}"
                                        class="action btn-secondary btn-custom"
                                    >{{ heroActions.button || $t('actions.subscribe', locale) }}</button>
                                </template>


                                <!-- Button: join course -->
                                <JoinCourse
                                    v-else-if="canJoin"
                                    :courseName="course.name"
                                    :courseId="course.id"
                                    :courseSlug="course.slug"
                                    :courseLocale="locale"
                                    class="action btn-secondary btn-custom"
                                >
                                    <span>{{ $t('actions.join', locale) }}</span>
                                </JoinCourse>


                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>

        <!-- Scroll to learn more -->
        <div class="hero-scroll transition-up-3">
            <span class="icon-anim-scroll mr-1" />
            <span class="fw-700">{{ $t('scroll-hint', locale) }}</span>
        </div>

    </div>
</template>


<script>
    let uid = 0;

    import WebpPicture  from '~/components/WebpPicture.vue';
    import numberFormat from '~/utilities/numberFormat.js';

    import { useCourseLandingStore } from '~/stores/courseLanding';

    import { platformPricing } from '~/utilities/pricing';

    import blockPropertyObject from '~/mixins/course-landing/blockPropertyObject.js';
    import courseStates        from '~/mixins/course-landing/courseStates.js';

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        components: {
            AddToCart:   () => import('~/components/cart/AddToCart.vue'),
            JoinCourse:  () => import('~/components/creative-practice/JoinCourseButton.vue'),
            WebpPicture,
        },


        mixins: [
            blockPropertyObject,
            courseStates,
        ],

        data () {
            uid++;

            return {
                linkOffset: -72,
                contentHeight: 0,

                // Hard coded for now; can be made dynamic in future
                subscriptionPrice: platformPricing.subscriptionReadOnly || 250,

                uid
            }
        },

        head () {
            const isVideo = this.heroVisual.video;

            const fallback   = !this.heroVisual.mobile;
            const lgFallback = !this.heroVisual.image;

            const src   = this.heroVisual.mobile || this.course.thumbnail;
            const lgSrc = this.heroVisual.image || this.course.thumbnail;
            const xlSrc = this.heroVisual.xlImage.src;

            let preload = [];

            const isUrlCDN = (url) => {
                if (!url) return false;
                const regex = /^https:\/\/cdn\.(?:[a-z0-9]+\.)?cases\.media\//;

                return regex.test(url);
            };

            const atSupportsWebp = (src, content) => {
                return `@supports (background-image: -webkit-image-set(url(${src}.webp) 1x)) { ${content} }`;
            };

            const atMedia = (query, content) => {
                return `@media screen and ${mediaQuery(query)} { ${content} }`;
            };

            const mediaQuery = (query) => {
                const arr = Array.isArray(query) ? query : [query];
                const str = arr.join(') and (');

                return `(${str})`;
            };

            const bgImageWebp = (src) => {
                return `background-image: -webkit-image-set(url(${src}.webp) 1x); background-image: image-set(url(${src}.webp) 1x);`;
            };

            const preloadImage = (src, query) => {
                const isCDN = isUrlCDN(src);
                let preload = {
                    rel: 'preload',
                    as:  'image',
                };

                if (isCDN) {
                    preload.href = `${src}.webp`;
                    preload.type = 'image/webp';
                } else {
                    preload.href = src;
                }

                if (query) preload.media = mediaQuery(query);

                return preload;
            };

            const preloadVideo = (src, type, query) => {
                let preload = {
                    rel:  'preload',
                    as:   'video',
                    href: src,
                };

                if (type)  preload.type = type;
                if (query) preload.media = mediaQuery(query);

                return preload;
            };

            const isCDN   = isUrlCDN(src);
            const isLgCDN = isUrlCDN(lgSrc);
            const isXlCDN = isUrlCDN(xlSrc);

            let css    = '';
            let cdnCss = '';

            // Mobile image
            css += `.visual { background-image: url(${src}); }`;

            if (isCDN) {
                // Use media query here to prevent mobile webp overwriting desktop image
                cdnCss += atSupportsWebp(src,
                    atMedia('max-width: 991px',
                        `.visual { ${bgImageWebp(src)} }`
                    )
                );

                preload.push(preloadImage(src, 'max-width: 991px'));
            }

            // Desktop image
            if (!isVideo) {
                css += atMedia('min-width: 992px',
                    `.visual { background-image: url(${lgSrc}); }`
                );

                let query = ['min-width: 992px'];

                if (xlSrc && isXlCDN) query.push('max-width: 1359px');

                if (isLgCDN) {
                    cdnCss += atSupportsWebp(lgSrc,
                        atMedia (query,
                            `.visual { ${bgImageWebp(lgSrc)} }`
                        )
                    )
                }

                preload.push(preloadImage(lgSrc, query));
            } else {
                for (const video of heroVisual.video) {
                    preload.push(preloadVideo(video.src, video.type, 'min-width: 992px'));
                }
            }

            // Wide desktop image
            if (!isVideo && !lgFallback && xlSrc) {
                css += atMedia('min-width: 1360px',
                    `.visual { background-image: url(${xlSrc}) }`
                );

                if (isXlCDN) {
                    cdnCss += atSupportsWebp(xlSrc,
                        atMedia('min-width: 1360px',
                            `.visual { ${bgImageWebp(xlSrc)} }`
                        )
                    );
                }

                preload.push(preloadImage(xlSrc, 'min-width: 1360px'));
            }

            let cssText = css + cdnCss;

            return {
                style: [
                    { type: 'text/css', cssText, },
                ],
                link: preload,
            };
        },

        computed: {
            dates () {
                if (this.block?.features?.dates) return this.block.features.dates;
                if (this.course?.startDate) {
                    let startDate = this.course.startDate;
                    return `${this.$timeformat['dd mmmm ????'](startDate, this.locale)}, ${this.$timeformat['hh:mm'](startDate, this.locale)}`
                }
                return '';
            },

            type () {
                if (this.block?.features?.type) return this.block.features.type;

                if (this.course?.moduleTypes) {
                    return this.course?.moduleTypes.includes('practice')
                            ? this.$t('tags.format.workshop', this.locale)
                            : this.$t('tags.format.webinar', this.locale)
                }
                return '';
            },

            locale () {
                return this.courseLandingStore.locale;
            },

            course () {
                return this.courseLandingStore.course;
            },

            courseLandingStore () {
                return useCourseLandingStore();
            },


            hasReviews () {
                return this.course.rating.length > 0;
            },

            hasStudents () {
                return this.course.students
                    && this.course.students > 0;
            },

            programBlockId () {
                const block = this.course?.blocks?.find(block => {
                    if (block.disabled) return false;
                    const type = block.type.toLowerCase();
                    return type == 'program'
                        || type == 'programgroup'
                        || type == 'programlegacy'
                        || type == 'programtable'
                        || type == 'monthesprogram'
                        || type == 'eventprogram';
                });

                if (!block) return false;

                // Use first block of type (uid == 1)
                return block.id || `${block.type}-1`;
            },

            applyBlockId () {
                const block = this.course?.blocks?.find(block => {
                    if (block.disabled) return false;;
                    const type = block.type.toLowerCase();
                    return type == 'subscribe'
                        || type == 'apply';
                });

                if (!block) return false;

                // Use first block of type (uid == 1)
                return block.id || `${block.type}-1`;
            },

            buyBlockId () {
                const block = this.course?.blocks?.find(block => {
                    if (block.disabled) return false;
                    const type = block.type.toLowerCase();
                    return type == 'buy'
                        || type == 'subscribe'
                        || type == 'subscribelegacy'
                        || type == 'customprice'
                        || type == 'comebackalive';
                });

                if (!block) return false;

                // Use first block of type (uid == 1)
                return block.id || `${block.type}-1`;
            },

            heroVisual () {
                let obj = Object.assign({
                    dark:  false,
                    color: false,
                    mask:  false,

                    video:  false,
                    image:  false,
                    width:  false,
                    height: false,

                    xlImage: false,

                    mobile: false,

                    btnColor: '#fc7e00',
                    btnLight: false,
                }, this.blockPropertyObject(this.block.visual, 'image'));

                // Set default fallback colors
                if (!obj.color) obj.color = obj.dark ? '#000' : '#fff';

                if (obj.video && !Array.isArray(obj.video)) {
                    // Convert single video source to array
                    obj.video = [obj.video];
                }

                obj.xlImage = Object.assign({
                    src: null,
                    id:  null,
                }, this.blockPropertyObject(this.block.visual?.xlImage || {}, 'src'));

                let hsl = this.hexToHsl(obj.btnColor);

                if (!hsl) hsl = [205.89, 78.49, 49.22];

                const [h, s, l] = hsl;

                obj.btnHue = h;
                obj.btnSaturation = s;
                obj.btnLightness = l;

                return obj;
            },

            heroImageSrc () {
                if (this.heroVisual.xlImage.src && this.$mq == 'xl') {
                    return this.heroVisual.xlImage.src;
                }

                return this.heroVisual.image;
            },

            heroTags () {
                let tags = Object.assign({
                    format:   'record',
                    topic:    false,
                    premiere: false,
                    start:    false,
                }, this.block.tags || {});

                // Format start date
                tags.start = this.tagsFormatStartDate(tags.start);

                return tags;
            },

            heroTitle () {
                let obj = this.blockPropertyObject(this.block.title, 'text');

                if (!obj.text) obj.text = this.course.name;

                return obj;
            },

            heroAbout () {
                return this.blockPropertyObject(this.block.about, 'text');
            },

            heroFeatures () {
                let obj = this.blockPropertyObject(this.block.features, 'items');

                if (!obj.duration && this.course.duration) obj.duration = this.course.duration;

                // Count modules dynamically, if data available
                if (obj.modules !== false) {
                    let modules = Object.assign({
                        count: 0,
                        label: 'modules'
                    }, this.blockPropertyObject(obj.modules, 'count'));

                    const isLive     = this.heroTags.format == 'live';
                    const hasProgram = this.course.program && this.course.program.length > 0;

                    if (hasProgram && (!isLive || !modules.count)) {
                        modules.count = this.course.program.filter(module => {
                            return !module.hidden;
                        }).length;
                    }

                    obj.modules = modules;
                }

                // Detect type dynamically, if not set
                if (!obj.type) {
                    const hasTheory   = this.course?.moduleTypes?.includes('theory');
                    const hasPractice = this.course?.moduleTypes?.includes('practice');
                    let key = false;

                    if (hasTheory && hasPractice) {
                        key = 'theoryPractice';
                    } else if (hasTheory) {
                        key = 'theory';
                    } else if (hasPractice) {
                        key = 'practice';
                    }

                    if (key) obj.type = this.$t(`features.types.${key}`, this.locale);
                }

                return obj;
            },

            heroPartners () {
                let obj;

                if (this.block?.partners) {
                    obj = this.blockPropertyObject(this.block.partners, 'items');
                } else {
                    obj = {
                        items: [],
                    };

                    // Legacy
                    let partner = this.blockPropertyObject(this.block?.partner, 'name');

                    let hasImage = partner.image && partner.image?.src
                              || partner.image?.light && partner.image?.dark;

                    if (partner.name || hasImage) {
                        obj.items.push(partner);
                    }
                }

                for (let index in obj.items) {
                    let item = obj.items[index];
                    item.image = this.blockPropertyObject(item.image, 'src');
                    obj.items[index] = item;
                }

                return obj;
            },

            heroPricing () {
                let obj = Object.assign({
                    price:    false,
                    discount: false,
                    suffix:   false,

                    full:         false,
                    fullDiscount: false,
                    fullSuffix:   false,

                    discountBadge: false,
                    minPrice:      false,

                    label: {},
                }, this.blockPropertyObject(this.block.pricing, 'price'));

                if (!obj.price && this.course.price) obj.price = this.course.price;
                if (!obj.discount && this.course.priceDiscount) obj.discount = this.course.priceDiscount;
                if (obj.price && obj.discount && !obj.discountBadge) {
                    let value = obj.price - obj.discount;
                    obj.discountBadge = `-${Math.floor(value * 100 / obj.price)}%`;
                }

                if (this.isCustomPrice && this.course.minPrice) {
                    obj.minPrice = this.course.minPrice;
                }

                return obj;
            },

            heroActions () {
                let obj = Object.assign({
                    button: false,
                }, this.blockPropertyObject(this.block.actions, 'button'));

                return obj;
            },

            hasSubscribePricingLink () {
                // Nowhere to link to
                if (!this.buyBlockId || !this.canSubAccess) return false;

                // Join/to Course buttons
                if (this.canJoin || this.isJoined) return true;

                // Course not launched or user already has access
                if (!this.isLaunched || this.hasAccess) return false;

                // Trial button
                if (this.canTrialAccess && this.hasTrial) return true;

                // Buy button
                if (this.canBuyAccess && this.course.buyAccess) return true;

                return false;
            },

            hasBuyPricingLink () {
                // Can't be bought
                if (!this.canBuyAccess || !this.course.buyAccess) return false;

                // Join/to Course buttons
                if (this.canJoin || this.isJoined) return true;

                // Course not launched or already bought
                if (!this.isLaunched || this.isBought) return false;

                // Trial button
                if (this.canTrialAccess && this.hasTrial) return true;

                return false;
            },


            isCurated () {
                const subBlock = this.course.blocks.find(block => {
                    if (block.disabled) return false;

                    const type = block.type.toLowerCase();

                    return type == 'subscribe';
                });

                if (!subBlock) return false;

                return !!subBlock.registerLink;
            },
        },

        mounted () {
            if (process.browser) {
                this.observe();
            }

            window.addEventListener('resize', this.updateContentHeight);

            this.updateContentHeight();
        },

        methods: {
            tagsFormatStartDate (start) {
                if (!start) return false;

                let date = start;

                if (typeof start == 'string') {
                    if (isNaN(Date.parse(start))) {
                        // Custom string
                        return start;
                    }

                    date = new Date(start);
                }

                if (!(date instanceof Date) || isNaN(date.getTime())) {
                    // Any other truthy value results in a "soon" start date
                    return this.$t('tags.soon', this.locale);
                }

                // Start date is valid, format
                let now = new Date();

                if (date <= now) {
                    // Date is in the past, remove the tag
                    return false;
                }

                return this.$timeformat['dd mmmm ????'](date);
            },


            updateContentHeight () {
                if (this.$refs.content) {
                    this.contentHeight = this.$refs.content.offsetHeight;
                }
            },


            hexToHsl (color) {
                const rgb = this.hexToRgb(color);

                if (!rgb) return false;

                const hsl = this.rgbToHsl(rgb);

                if (!hsl) return false;

                return hsl;
            },

            hexToRgb (hex) {
                // Extract R G and B from hex code
                const short = /^#?(?<r>[a-f0-9])(?<g>[a-f0-9])(?<b>[a-f0-9])$/i;
                const long  = /^#?(?<r>[a-f0-9]{2})(?<g>[a-f0-9]{2})(?<b>[a-f0-9]{2})$/i;

                let regex = long;

                if (hex.length == 3 || hex.length == 4) regex = short;
                else if (hex.length != 6 && hex.length != 7) return false;

                const match = hex.match(regex);

                if (!match || !match.groups) return false;

                let { r, g, b } = match.groups;

                // Normalize length
                if (r.length == 1) r += r;
                if (g.length == 1) g += g;
                if (b.length == 1) b += b;

                // Convert hex to int
                r = parseInt(r, 16);
                g = parseInt(g, 16);
                b = parseInt(b, 16);

                return [r, g, b];
            },

            rgbToHsl (rgb) {
                let [r, g, b] = rgb;

                // https://gist.github.com/mjackson/5311256
                r /= 255, g /= 255, b /= 255;

                let max = Math.max(r, g, b), min = Math.min(r, g, b);
                let h, s, l = (max + min) / 2;

                if (max == min) {
                    h = s = 0; // achromatic
                } else {
                    let d = max - min;
                    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                    switch (max) {
                        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                        case g: h = (b - r) / d + 2; break;
                        case b: h = (r - g) / d + 4; break;
                    }

                    h /= 6;
                }

                // Convert to degrees/percentages
                h = Math.round(36000 * h) / 100;
                s = Math.round(10000 * s) / 100;
                l = Math.round(10000 * l) / 100;

                return [ h, s, l ];
            },


            numberFormat (x) {
                return numberFormat(x, this.locale);
            },


            observe () {
                this.observer = new IntersectionObserver((entries) => {
                    const entry = entries.find(e => e.isIntersecting);
                    const visible = entry && entry.intersectionRatio >= 0.25;
                    this.$emit('intersection', {
                        type: 'Hero',
                        threshold: 0.25,
                        isVisible: visible
                    });
                }, {
                    rootMargin: '0px',
                    threshold: [0, 0.03, 0.1, 0.25, 0.5, 0.75, 1.0]
                });

                const blockId = this.block.id || `${this.block.type}-${this.uid}`;

                const el = document.querySelector(`#${blockId}`);
                if (el) this.observer.observe(el);
            },

            unobserve: function () {
                if (this.observer) this.observer.disconnect();
            },
        },

        destroyed () {
            this.unobserve();

            window.removeEventListener('resize', this.updateContentHeight);
        },
    }
</script>


<style lang="postcss" scoped>
    .hero-block {
        --hero-btn-hue:   30;
        --hero-btn-sat:   100%;
        --hero-btn-light: 49.41%;

        position: relative;

        @media screen and (min-width: 992px) {
            color: #000;

            /* height:     calc(100vh - var(--top-bar-height)); */
            height:     100vh;
            max-height: 970px;

            display:         flex;
            flex-flow:       row nowrap;
            align-items:     center;
            justify-content: center;

            &.dark {
                color: #fff;
            }

            :deep(.color-gray-3) {
                color: #878d99;
            }

            :deep(.color-yellow-2) {
                color: #FFD601;
            }

            :deep(.btn-primary) {
                color: #fff;
                background-color: #0E1014;

                &:hover,
                &.exact-active,
                &.active {
                    background-color: #595E69;
                }

                &:active {
                    background-color: #0E1014 !important;
                }

                &.disabled,
                &:disabled {
                    color: #F5F7FA !important;
                    background-color: #A8B0BF !important;

                    .color-gray-3 {
                        color: #DDE1EB !important;
                    }
                }
            }

            :deep(.b-link) {
                color: #1f92cc;

                &:hover {
                    color: #000;
                }
            }

            .groupped-link:hover :deep(.b-link) {
                color: #000;
            }

            &.dark {
                :deep(.color-gray-3) {
                    color: #A8B0BF;
                }

                :deep(.color-yellow-2) {
                    color: #FFD601;
                }

                :deep(.btn-primary) {
                    color: #0E1014;
                    background-color: #fff;

                    &:hover,
                    &.exact-active,
                    &.active {
                        background-color: #98a1b4;
                    }

                    &:active {
                        background-color: #fff !important;
                    }

                    &.disabled,
                    &:disabled {
                        color: #1a1a1d !important;
                        background-color: #4d5461 !important;

                        .color-gray-3 {
                            color: #3d3e4a !important;
                        }
                    }
                }

                :deep(.b-link) {
                    color: #FFCE0A;

                    &:hover {
                        color: #fff;
                    }
                }

                .groupped-link:hover :deep(.b-link) {
                    color: #fff;
                }
            }
        }
    }

    .hero-visual {
        @media screen and (max-width: 991px) {
            background-color: transparent !important;
        }

        @media screen and (min-width: 992px) {
            position: absolute;
            top:      0;
            right:    0;
            bottom:   0;
            left:     0;
            z-index:  0;
            overflow: hidden;
        }

        .visual {
            background-position: 50% 50%;
            background-repeat:   no-repeat;
            background-size:     auto 100%;

            margin-right: -16px;
            margin-left:  -16px;

            width:     calc(100% + 32px);
            height:    180px;
            max-width: none;

            @media screen and (min-width: 576px) {
                border-radius: 8px;
                margin-left: 0;
                margin-right: 0;
                width:  100%;
                height: 240px;
            }

            @media screen and (min-width: 992px) {
                margin:        0;
                border-radius: 0;

                height: auto;

                position: absolute;
                top:      0;
                right:    0;
                bottom:   0;
                left:     0;
                z-index:  1;
                overflow: hidden;
            }

            &.fallback {
                @media screen and (max-width: 991px) {
                    background-size: cover;
                }
            }

            &.lg-fallback {
                @media screen and (min-width: 992px) {
                    background-size: cover;
                }
            }
        }

        .visual-video {
            transform: translateX(-50%);

            display:   block;
            width:     auto;
            height:    100%;
            max-width: none;

            position: relative;
            left:     50%;

            @media screen and (max-width: 991px) {
                display: none;
            }

            ~ .page-container > .visual {
                @media screen and (min-width: 992px) {
                    display: none;
                }
            }
        }

        .mask {
            @media screen and (min-width: 992px) {
                display: block;
                width:   100%;
                height:  100%;

                &::before {
                    content: '';

                    background: #fff;
                    opacity:    .5;

                    position: absolute;
                    top:      0;
                    right:    0;
                    bottom:   0;
                    left:     0;
                    z-index:  2;

                    .hero-block.dark & {
                        background: #000;
                    }
                }
            }
        }

        .visual ~ .mask {
            position: absolute;
            top:      0;
            right:    0;
            bottom:   0;
            left:     0;
            z-index:  2;
        }
    }

    .hero-content {
        position: relative;
        width: 100%;

        @media screen and (min-width: 992px) {
            padding-top:    16px;
            padding-bottom: 16px;
        }
    }



    .hero-about,
    .hero-partners,
    .hero-pricing,
    .hero-actions,
    .hero-cover {
        margin-top:    12px;
        margin-bottom: 12px;

        @media screen and (min-width: 576px) and (max-width: 991px) {
            &:first-child {
                margin-top: 0;
            }
        }

        @media screen and (max-width: 991px) {
            &:last-child {
                margin-bottom: 0;
            }
        }

        @media screen and (min-width: 576px) {
            margin-top:    16px;
            margin-bottom: 16px;
        }

        @media screen and (min-width: 992px) {
            margin-top:    12px;
            margin-bottom: 12px;
        }
    }


    .hero-title {
        font-size:   24px;
        line-height: 28px;

        @media screen and (min-width: 576px) {
            font-size:   32px;
            line-height: 36px;
        }

        @media screen and (min-width: 768px) {
            font-size:   36px;
            line-height: 38px;
        }

        @media screen and (min-width: 992px) {
            font-size:   38px;
            line-height: 42px;
        }
    }

    .hero-about {
        font-size:   19px;
        line-height: 24px;
    }


    .feature {
        display: inline-flex;
        align-items: center;

        & + &::before {
            content:     '';
            display: block;
            background-color: var(--color-cases-gray-2);
            margin: 0 8px;
            width: 4px;
            height: 4px;
            border-radius: 50%;

            @media (prefers-color-scheme: dark) {
                background-color: rgba(255, 255, 255, .5);
            }

            [data-theme='dark'] & {
                background-color: rgba(255, 255, 255, .5);
            }

            [data-theme='light'] & {
                background-color: var(--color-cases-gray-2);
            }

            @media screen and (min-width: 992px) {
                background-color: #878D99;

                .hero-block.dark & {
                    background-color: rgba(255, 255, 255, .5);
                }
            }
        }
    }


    .hero-partners {
        display:         flex;
        flex-flow:       row nowrap;
        align-items:     center;
        justify-content: flex-start;

        .icon + .name {
            margin-left: 4px;
        }

        @media screen and (min-width: 992px) {
            .scheme-dark-block {
                display: none !important;

                .hero-block.dark & {
                    display: block !important;
                }
            }

            .scheme-light-block {
                display: block !important;

                .hero-block.dark & {
                    display: none !important;
                }
            }
        }
    }

    .partner {
        display:     flex;
        flex-flow:   row nowrap;
        align-items: center;

        > picture,
        :deep(img) {
            object-fit:      cover;
            object-position: 50% 0;

            display: block;
        }
    }

    .hero-pricing {
        text-align: center;

        @media screen and (min-width: 576px) {
            text-align: left;
        }
    }

    .pricing-backdrop {
        text-align: left;

        background: var(--color-cases-gray-5);

        border-radius: 8px;
        padding:       12px;

        display: flex;
        justify-content: center;

        @media screen and (min-width: 576px) {
            display: none;
        }

        @media screen and (min-width: 992px) {
            display: inline-block;

            background:      rgba(0, 0, 0, 0.05);
            backdrop-filter: blur(20px);

            .hero-block.dark & {
                background: rgba(9, 10, 13, 0.25);
            }
        }
    }

    .pricing-access,
    .pricing-sub,
    .pricing-charity {
        font-size:   14px;
        line-height: 1.428571;

        display:     flex;
        flex-flow:   row nowrap;
        align-items: center;

        @media screen and (min-width: 576px) {
            font-size:   16px;
            line-height: 1.25;
        }

        &::before {
            content: '';

            background-repeat:   no-repeat;
            background-position: 50% 50%;
            background-size:     24px 24px;

            margin-right: 8px;

            flex: 0 0 24px;

            display: block;
            width:   24px;
            height:  24px;
        }
    }

    .pricing-access {
        font-weight: bold;

        &::before {
            background-image: url(data:image/svg+xml;base64,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);
            background-size: 32px 32px;

            margin-right: 8px;

            width:  32px;
            height: 32px;

            flex-basis: 32px;
        }
    }

    .pricing-sub {
        &::before {
            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjUgNC41QzEuNSAzLjY3MTU3IDIuMTcxNTcgMyAzIDNIMjFDMjEuODI4NCAzIDIyLjUgMy42NzE1NyAyMi41IDQuNVYxMy41QzIyLjUgMTQuMzI4NCAyMS44Mjg0IDE1IDIxIDE1SDNDMi4xNzE1NyAxNSAxLjUgMTQuMzI4NCAxLjUgMTMuNVY0LjVaTTEyLjIzMTYgNC4xMjVMMTMuMzQyOCA3LjU3MDYxTDE2Ljk2MzIgNy41NjI2OUwxNC4wMjk2IDkuNjg0MjhMMTUuMTU1OSAxMy4xMjVMMTIuMjMxNiAxMC45OTA2TDkuMzA3MyAxMy4xMjVMMTAuNDMzNiA5LjY4NDI4TDcuNSA3LjU2MjY5TDExLjEyMDQgNy41NzA2MUwxMi4yMzE2IDQuMTI1WiIgZmlsbD0iI0ZGQ0UwQSIvPgo8cGF0aCBkPSJNMTkuNSAxOEg0LjVWMTkuNUM0LjUgMjAuMzI4NCA1LjE3MTU3IDIxIDYgMjFIMThDMTguODI4NCAyMSAxOS41IDIwLjMyODQgMTkuNSAxOS41VjE4WiIgZmlsbD0iI0ZGQ0UwQSIvPgo8L3N2Zz4K);
        }
    }

    .pricing-charity {
        &::before {
            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMTUuNSIgd2lkdGg9IjUiIGhlaWdodD0iNyIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAzIDE1LjUpIiBmaWxsPSIjRkZDRTBBIi8+CjxwYXRoIGQ9Ik0xNi42NTU5IDE1LjU2ODFMMjAuNSAxMEwxNi45NTExIDEyLjU3NDRDMTYuNzY4OCAxMi43MDY3IDE2LjU0NzIgMTIuNzczNSAxNi4zMjIyIDEyLjc2NDFMMTEuNDA0MyAxMi41NTg3QzEwLjcxNzEgMTIuNTMgMTAuMjA2OCAxMy4xODczIDEwLjQwNDkgMTMuODQ1OUwxMC44Mzg4IDE1LjI4ODFDMTAuOTY2IDE1LjcxMDcgMTEuMzU1MSAxNiAxMS43OTY0IDE2SDE1LjgzM0MxNi4xNjE2IDE2IDE2LjQ2OTMgMTUuODM4NiAxNi42NTU5IDE1LjU2ODFaIiBmaWxsPSIjRkZDRTBBIiBzdHJva2U9IiNGRkNFMEEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMgM0MxMS44OTU0IDMgMTEgMy44OTU0MyAxMSA1QzExIDggMTQuNSAxMCAxNC41IDEwQzE0LjUgMTAgMTggOCAxOCA1QzE4IDMuODk1NDMgMTcuMTA0NiAzIDE2IDNDMTUuNDAyNyAzIDE0Ljg2NjUgMy4yNjE4OCAxNC41IDMuNjc3MDlDMTQuMTMzNSAzLjI2MTg4IDEzLjU5NzMgMyAxMyAzWiIgZmlsbD0iI0Y0N0Q4NyIvPgo8L3N2Zz4K);
        }
    }

    .pricing-price {
        font-size:   20px;
        line-height: 1;

        display:   flex;
        flex-flow: row nowrap;

        @media screen and (min-width: 576px) {
            font-size: 24px;
        }

        strike {
            margin-right: 4px;
        }

        sup,
        .currency {
            font-size:   16px;
            line-height: 1;

            display:     flex;
            flex-flow:   row nowrap;
            align-items: center;
            align-self:  center;
        }

        sup {
            top: -8px;
        }

        .currency {
            margin-left: 4px;
        }

        &.large {
            font-size: 28px;

            justify-content: flex-start;

            @media screen and (min-width: 992px) {
                font-size: 32px;

                justify-content: flex-start;
            }
        }
    }

    .pricing-discount {
        color:          #0E1014;
        font-size:      8px;
        font-weight:    bold;
        letter-spacing: -0.24px;
        line-height:    1;

        background: #ffce0b;

        margin-left:   2px;
        border-radius: 4px;
        padding:       2px;

        display: inline-block;

        @media screen and (min-width: 576px) {
            font-size: 12px;
        }
    }

    .reset-btn {
        text-align: left;

        appearance: none;
        background: transparent;

        outline: 0;
        border:  0;
        padding: 0;
    }

    .pricing-group {
        display:         flex;
        flex-flow:       row nowrap;
        align-items:     center;
        justify-content: space-between;

        @media screen and (min-width: 576px) {
            justify-content: flex-start;
        }

        .groupped {
            text-align: left;

            appearance: none;
            background: transparent;

            outline: 0;
            border:  0;
            padding: 0;

            flex: 1 1 50%;

            @media screen and (min-width: 576px) {
                min-width: 164px;
            }
        }

        .groupped-link {
            color: inherit;

            &:hover .b-link {
                color: var(--color-cases-text);
            }
        }

        .conj {
            font-size:   12px;
            font-weight: bold;
            line-height: 1.333333;

            margin-right: 12px;
            margin-left:  12px;

            @media screen and (min-width: 576px) {
                font-size:   16px;
                line-height: 1.5;

                margin-right: 16px;
                margin-left:  16px;
            }
        }
    }

    .pricing-link {
        font-size:   12px;
        font-weight: bold;
        line-height: 16px;

        @media screen and (min-width: 576px) {
            font-size: 14px;
        }
    }

    .actions {
        margin: -4px;

        display:   flex;
        flex-flow: row wrap;

        @media screen and (min-width: 576px) {
            justify-content: flex-start;
        }
    }

    .action {
        text-transform: uppercase;

        margin: 4px;

        flex: 1 0 100%;

        @media screen and (min-width: 576px) {
            padding: 16px;

            flex:       1 1 50%;
            flex-basis: calc(50% - 8px);
        }

        @media screen and (min-width: 992px) {
            flex: 0 0 auto;
        }
    }

    .btn-custom {
        color:       #fff;
        font-weight: 600;

        background: hsl(var(--hero-btn-hue), var(--hero-btn-sat), var(--hero-btn-light));

        &:hover {
            background: hsl(var(--hero-btn-hue), var(--hero-btn-sat), calc(var(--hero-btn-light) + 10%));
        }

        &:active {
            background: hsl(var(--hero-btn-hue), var(--hero-btn-sat), calc(var(--hero-btn-light) - 10%));
        }

        .hero-block.hero-btn-light & {
            color: #000000;
        }
    }

    .hero-cover {
        margin-right: -16px;
        margin-left:  -16px;

        display: block;
        height:  180px;

        overflow: hidden;

        @media screen and (min-width: 576px) {
            margin-top:   16px;
            margin-right: 0;
            margin-left:  0;

            border-radius: 8px;

            height: 240px;

            overflow: hidden;
        }

        @media screen and (min-width: 992px) {
            display: none;
        }

        .cover,
        :deep(img) {
            transform: translateX(-50%);

            display:   block;
            width:     auto;
            height:    100%;
            max-width: none;

            position: relative;
            left:     50%;
        }
    }

    .hero-scroll {
        color: #717885;

        font-size:   12px;
        line-height: 1.333333;
        text-align:  center;

        margin:  0;
        padding: 4px 0;

        display:         none;
        flex-flow:       row nowrap;
        justify-content: center;

        position: absolute;
        right:    0;
        bottom:   32px;
        left:     0;
        z-index:  2;

        @media screen and (min-width: 992px) {
            display: flex;
        }

        .hero-block.dark & {
            color: inherit;
        }

        > .icon-ic-mice {
            font-size: 18px;

            margin: -1px 0;
            margin-right: 6px;

            display: block;
        }
    }

    .icon-anim-scroll {
        margin: -1px 0;
        border: 2px solid currentColor;
        border-radius: 9000px;

        display: block;
        width:   12px;
        height:  18px;

        position: relative;

        &::before {
            content: '';

            animation:  icon-anim-scroll 1.6s ease infinite;
            background: currentColor;

            border-radius: 50%;

            display: block;
            width:   2px;
            height:  2px;

            position: absolute;
            top:      2px;
            left:     3px;
        }
    }

    @keyframes icon-anim-scroll {
        to {
            opacity:   0;
            transform: translateY(5px);
        }
    }

    .edit {
        position: absolute;
        top:      16px;
        right:    16px;
        z-index:  10;
    }
</style>
